import { fKeyTabInput } from "../../../Utility/Utilitys";
import { Box, Card, CardContent, Grid } from "@mui/material";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpInputField,
} from "../../../Component/Common/ToolBox/ToolBox";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";

export default function WmsContent({
  sEnterKeyObj,
  xContent_Focus,
  xContent_Blur,
  xErrorMsgDetail,

  xBufferObj,
  sUnit,

  fUnit,
  fQty,
  fQty_Enter,
  fShelfNo_Enter,
  fBarcode,
  fShelfNo,
  fBarcodeEnter,
  fItemName,

  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,
}) {
  return (
    <Box>
      <Card
        elevation={6}
        sx={{
          borderRadius: 4,
          width: "100%",
          backdropFilter: "blur(10px)",
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.8), rgba(245,247,250,0.75))",
          boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <CardContent>
          <Grid
            container
            spacing={{xs:1, sm:1, md:1, lg:2}}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          >
            {/* S.No */}
            <Grid item xs={4} sm={4} md={4}>
              <CmpTypographyField xcomponent={"div"} xText={"S.No"} />
              <CmpInputField
                xValue={xBufferObj.B_Srno}
                xType={"text"}
                xName={"B_Srno"}
                xReadOnly={true}
                xError={xErrorMsgDetail.B_Srno !== ""}
                xErrorMessage={xErrorMsgDetail.B_Srno}
              />
            </Grid>

            {/* Barcode */}
            <Grid item xs={8} sm={8} md={8}>
              <CmpTypographyField xcomponent={"div"} xText={"Barcode"} />
              <GCToggleSearch
                xtabIndex={"101"}
                xName={"B_Barcode"}
                xType={"text"}
                xValue={xBufferObj?.B_Barcode}
                xReadOnly={false}
                xOnChange={fBarcode}
                xOnKeyUp={fBarcodeEnter}
                xError={xErrorMsgDetail.B_Barcode !== ""}
                xErrorMessage={xErrorMsgDetail.B_Barcode}
                xMediaQuery={xMediaQuery}
                xonClickbtn={fBarcodeEnter}
              />
            </Grid>

            {/* Item Code */}
            <Grid item xs={12} sm={4} md={4}>
              <CmpTypographyField xcomponent={"div"} xText={"Item Code"} />
              <CmpInputField
                xValue={xBufferObj.B_Itmcd}
                xType={"text"}
                xName={"B_Itmcd"}
                xReadOnly={true}
                xError={xErrorMsgDetail.B_Itmcd !== ""}
                xErrorMessage={xErrorMsgDetail.B_Itmcd}
              />
            </Grid>

            {/* Item Name */}
            <Grid item xs={12} sm={8} md={8}>
              <CmpTypographyField xcomponent={"span"} xText={"Item Name"} />
              <GCToggleSearch
                xtabIndex={"102"}
                xName={"B_ItmName"}
                xType={"text"}
                xValue={xBufferObj?.B_ItmName}
                xReadOnly={false}
                xOnChange={fItemName}
                xOnKeyUp={xonClickbtn}
                xError={xErrorMsgDetail.B_ItmName !== ""}
                xErrorMessage={xErrorMsgDetail.B_ItmName}
                xMediaQuery={xMediaQuery}
                xonClickbtn={xonClickbtn}
                xrows={xrows}
                xcolumns={xcolumns}
                xRowCellClick={xRowCellClick}
                xRowClick={xRowClick}
                xToggle={xToggle}
                xData={xData}
                xOnChangeDropdownInput={xOnChangeDropdownInput}
                xDropdownObj={xDropdownObj}
                xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
              />
            </Grid>

            {/* Qty */}
            <Grid item xs={6} sm={2} md={4}>
              <CmpTypographyField xcomponent={"div"} xText={"Qty"} />
              <CmpInputField
                xtabIndex={"103"}
                xValue={xBufferObj?.B_Qty}
                xType={"number"}
                xName={"B_Qty"}
                xReadOnly={false}
                xOnChange={fQty}
                xError={xErrorMsgDetail.B_Qty !== ""}
                xErrorMessage={xErrorMsgDetail.B_Qty}
                xOnKeyUp={fQty_Enter}
                xonFocus={xContent_Focus}
                xonBlur={xContent_Blur}
              />
            </Grid>

            {/* Unit */}
            <Grid item xs={6} sm={3} md={8}>
              <CmpTypographyField xcomponent={"div"} xText={"Unit"} />
              <CmpSelectField
                xtabIndex={"104"}
                xLabelText="Unit"
                xValue={xBufferObj.B_Unit}
                xOnChange={fUnit}
                xName={"B_Unit"}
                xData={sUnit}
                xError={xErrorMsgDetail.B_Unit !== ""}
                xErrorMessage={xErrorMsgDetail.B_Unit}
              />
            </Grid>

            {/* Packing */}
            <Grid item xs={4.5} sm={2.5} md={4}>
              <CmpTypographyField xcomponent={"div"} xText={"Packing"} />
              <CmpInputField
                xtabIndex={"105"}
                xValue={xBufferObj.B_Packing}
                xType={"text"}
                xName={"B_Packing"}
                xReadOnly={true}
                xError={xErrorMsgDetail.B_Packing !== ""}
                xErrorMessage={xErrorMsgDetail.B_Packing}
              />
            </Grid>

            {/* Base Qty */}
            <Grid item xs={3.5} sm={2} md={4}>
              <CmpTypographyField xcomponent={"div"} xText={"Base Qty"} />
              <CmpInputField
                xtabIndex={"106"}
                xValue={xBufferObj.B_BaseQty}
                xType={"text"}
                xName={"B_BaseQty"}
                xReadOnly={true}
                xError={xErrorMsgDetail.B_BaseQty !== ""}
                xErrorMessage={xErrorMsgDetail.B_BaseQty}
              />
            </Grid>

  <Grid item xs={4} sm={2.5} md={4}>
              <CmpTypographyField xcomponent={"div"} xText={"Shelf.No"} />
              <CmpInputField
                xtabIndex={"103"}
                xValue={xBufferObj?.shelfNo}
                xType={"number"}
                xName={"shelfNo"}
                xReadOnly={false}
                xOnChange={fShelfNo}
                xError={xErrorMsgDetail.shelfNo !== ""}
                xErrorMessage={xErrorMsgDetail.shelfNo}
                xOnKeyUp={fShelfNo_Enter}
                xonFocus={xContent_Focus}
                xonBlur={xContent_Blur}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}
